import { Timer, Phone, ShoppingBag } from "lucide-react";
import { CAFE, IMAGES } from "../data/cafeData";

const PERKS = [
  { icon: Phone, text: "Call ahead and we'll have your order ready at the counter" },
  { icon: Timer, text: "Pickup is usually ready in about 10 minutes" },
  { icon: ShoppingBag, text: "Full menu available for takeout, made exactly how you like it" },
];

export const OrderSection = () => (
  <section id="order" data-testid="order-section" className="grain-overlay bg-[#21150C] py-24 md:py-32">
    <div className="relative z-10 mx-auto grid max-w-6xl items-center gap-14 px-5 md:grid-cols-2 md:px-8 lg:gap-20">
      <div>
        <p className="font-accent text-xs font-semibold uppercase tracking-[0.25em] text-[#D49B4B]">
          Online Ordering
        </p>
        <h2 className="mt-4 font-serif text-2xl font-bold tracking-tight text-[#FDFBF7] sm:text-3xl lg:text-4xl">
          Order-ahead is
          <br />
          <em className="font-medium italic text-[#E9C9A8]">brewing — coming soon.</em>
        </h2>
        <p className="mt-6 max-w-md text-base leading-relaxed text-[#FDFBF7]/75">
          We're putting the finishing touches on online ordering. Until then, give us a
          call and your drink will be waiting at the counter with your name on it.
        </p>

        <div className="mt-8 space-y-4">
          {PERKS.map((perk, i) => (
            <div key={i} className="flex items-center gap-4" data-testid={`order-perk-${i}`}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#C86D51]/20 text-[#E8A08A]">
                <perk.icon size={17} />
              </span>
              <p className="text-sm leading-relaxed text-[#FDFBF7]/80">{perk.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <a
            href={CAFE.phoneHref}
            data-testid="order-call-button"
            className="inline-flex items-center gap-2.5 rounded-full bg-[#C86D51] px-8 py-4 font-accent text-sm font-semibold text-[#FDFBF7] shadow-lg shadow-[#C86D51]/20 transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#B35B40]"
          >
            <Phone size={15} />
            Call {CAFE.phone}
          </a>
          <span
            data-testid="order-toast-button"
            className="inline-flex cursor-not-allowed items-center gap-2.5 rounded-full bg-[#3D3227] px-8 py-4 font-accent text-sm font-semibold text-[#FDFBF7]/45 select-none"
            title="Online ordering is coming soon"
          >
            <ShoppingBag size={15} />
            Order Online · Coming Soon
          </span>
        </div>
      </div>

      <div className="relative">
        <div className="overflow-hidden rounded-[2rem]">
          <img
            src={IMAGES.espresso}
            alt="Nomad Cafe signature drinks lined up at the counter"
            className="aspect-[4/5] w-full object-cover md:aspect-[5/6]"
          />
        </div>
        <div className="absolute -bottom-6 -left-4 rounded-2xl bg-[#FDFBF7] px-6 py-5 shadow-2xl md:-left-8" data-testid="order-pickup-card">
          <p className="font-accent text-[10px] font-semibold uppercase tracking-[0.2em] text-[#C86D51]">
            Average pickup
          </p>
          <p className="mt-1 font-serif text-3xl font-bold text-[#2C1D11]">~10 min</p>
        </div>
      </div>
    </div>
  </section>
);
